export const rc07 = '#FFAB00';
export const rc11 = '#6E382D';
export const rc10 = '#E33E38';
export const rc09 = '#FF708B';
export const rc08 = '#FF7A00';
export const rc06 = '#FFEB3A';
export const rc05 = '#52C41B';
export const rc04 = '#30C28B';
export const rc03 = '#55CDFF';
export const rc02 = '#5586FF';
export const rc01 = '#7B67EE';
export const rc00 = '#B35FF5';
export const bgControlsDegradeHigh = 'rgba(0, 0, 0, 0.24)';
export const bgControlsDegradeDefault = 'rgba(0, 0, 0, 0.12)';
export const bgControlsHoverSolid = 'rgba(67, 67, 67, 1)';
export const bgControlsDefaultSolid = 'rgba(49, 49, 49, 1)';
export const bgControlsActiveSolid = 'rgba(85, 85, 85, 1)';
export const bgBrandLightHoverSolid = 'rgba(53, 48, 81, 1)';
export const bgBrandLightActiveSolid = 'rgba(60, 54, 97, 1)';
export const bgBrandLightDefaultSolid = 'rgba(46, 43, 64, 1)';
export const bgLogoText = 'rgba(255, 255, 255, 0.85)';
export const bgLogoIcon = 'rgba(255, 255, 255, 0.85)';
export const rainbowGray5 = 'rgba(181, 181, 181, 1)';
export const rainbowGray4 = 'rgba(181, 181, 181, 0.8)';
export const rainbowGray3 = 'rgba(181, 181, 181, 0.6)';
export const rainbowGray2 = 'rgba(181, 181, 181, 0.4)';
export const rainbowGray1 = 'rgba(181, 181, 181, 0.2)';
export const borderOnwarnLight = 'rgba(255, 166, 42, 0.24)';
export const borderOnwarnDefault = 'rgba(255, 183, 82, 1)';
export const borderWarnHover = 'rgba(255, 183, 82, 1)';
export const borderWarnDisabled = 'rgba(255, 166, 42, 0.5)';
export const borderWarnDefault = 'rgba(255, 166, 42, 1)';
export const borderWarnActive = 'rgba(255, 199, 120, 1)';
export const borderSuccessDisabled = 'rgba(60, 214, 163, 0.5)';
export const borderSuccessActive = 'rgba(141, 235, 203, 1)';
export const borderOnsuccessLight = 'rgba(60, 214, 163, 0.24)';
export const borderOnsuccessDefault = 'rgba(99, 224, 183, 1)';
export const borderSuccessHover = 'rgba(99, 224, 183, 1)';
export const borderSuccessDefault = 'rgba(60, 214, 163, 1)';
export const borderOndangerLight = 'rgba(238, 83, 71, 0.24)';
export const borderOndangerDefault = 'rgba(245, 144, 137, 1)';
export const borderDangerDisabled = 'rgba(240, 115, 105, 0.5)';
export const textStaticDisabled = 'rgba(255, 255, 255, 0.3)';
export const textReverseDefault = 'rgba(51, 51, 51, 1)';
export const textStaticTertiary = 'rgba(255, 255, 255, 0.6)';
export const textStaticSecondary = 'rgba(255, 255, 255, 0.8)';
export const textStaticPrimary = 'rgba(255, 255, 255, 1)';
export const rainbowYellow5 = ' rgba(255, 195, 16, 1)';
export const rainbowYellow4 = ' rgba(255, 195, 16, 0.8)';
export const rainbowYellow3 = ' rgba(255, 195, 16, 0.6)';
export const rainbowYellow2 = ' rgba(255, 195, 16, 0.4)';
export const rainbowYellow1 = ' rgba(255, 223, 64, 0.2)';
export const bgStaticDarkHigh = 'rgba(79, 84, 92, 1)';
export const bgReverseDefault = 'rgba(224, 224, 224, 1)';
export const bgGradientVertical = '0deg, #1A1A1A 0%, rgba(26, 26, 26, 0) 100%';
export const bgGradientHorizontal = '270deg, #1A1A1A 0%, rgba(26, 26, 26, 0) 100%';
export const textWarnHover = 'rgba(255, 183, 82, 1)';
export const textWarnDisabled = 'rgba(255, 166, 42, 0.5)';
export const textWarnDefault = 'rgba(255, 166, 42, 1)';
export const textWarnActive = 'rgba(255, 199, 120, 1)';
export const textSuccessHover = 'rgba(99, 224, 183, 1)';
export const textSuccessDisabled = 'rgba(60, 214, 163, 0.5)';
export const textSuccessDefault = 'rgba(60, 214, 163, 1)';
export const textSuccessActive = 'rgba(141, 235, 203, 1)';
export const textLinkVisted = 'rgba(123, 103, 238, 1)';
export const textLinkHover = 'rgba(168, 154, 245, 1)';
export const textLinkDisabled = 'rgba(144, 127, 240, 0.5)';
export const textLinkDefault = 'rgba(144, 127, 240, 1)';
export const textLinkActive = 'rgba(192, 182, 250, 1)';
export const textDangerHover = 'rgba(245, 144, 137, 1)';
export const textDangerDisabled = 'rgba(240, 115, 105, 0.5)';
export const textDangerDefault = 'rgba(240, 115, 105, 1)';
export const textDangerActive = 'rgba(250, 175, 170, 1)';
export const textCommonTertiary = 'rgba(255, 255, 255, 0.55)';
export const textCommonSecondary = 'rgba(255, 255, 255, 0.7)';
export const textCommonQuaternary = 'rgba(255, 255, 255, 0.4)';
export const textCommonPrimary = 'rgba(255, 255, 255, 0.85)';
export const textCommonDisabled = 'rgba(255, 255, 255, 0.25)';
export const textBrandHover = 'rgba(168, 154, 245, 1)';
export const textBrandDisabled = 'rgba(144, 127, 240, 0.5)';
export const textBrandDefault = 'rgba(144, 127, 240, 1)';
export const textBrandActive = 'rgba(192, 182, 250, 1)';
export const borderOnbrandLight = 'rgba(144, 127, 240, 0.24)';
export const borderOnbrandDefault = 'rgba(168, 154, 245, 1)';
export const borderGridVertical = 'rgba(61, 61, 61, 1)';
export const borderGridHorizontal = 'rgba(61, 61, 61, 1)';
export const borderDangerHover = 'rgba(224, 113, 105, 1)';
export const borderDangerDefault = 'rgba(213, 84, 75, 1)';
export const borderDangerActive = 'rgba(232, 143, 137, 1)';
export const borderCommonHover = 'rgba(255, 255, 255, 0.16)';
export const borderCommonDisabled = 'rgba(255, 255, 255, 0.8)';
export const borderCommonDefault = 'rgba(255, 255, 255, 0.12)';
export const borderCommonActive = 'rgba(255, 255, 255, 0.2)';
export const borderBrandHover = 'rgba(168, 154, 245, 1)';
export const borderBrandDisabled = 'rgba(144, 127, 240, 0.5)';
export const borderBrandDefault = 'rgba(144, 127, 240, 1)';
export const borderBrandActive = 'rgba(192, 182, 250, 1)';
export const bgWarnLightHover = 'rgba(255, 166, 42, 0.24)';
export const bgWarnLightDisabled = 'rgba(255, 166, 42, 0.08)';
export const bgWarnLightDefault = 'rgba(255, 166, 42, 0.16)';
export const bgWarnLightActive = 'rgba(255, 166, 42, 0.32)';
export const bgWarnHover = 'rgba(255, 183, 82, 1)';
export const bgWarnDisabled = 'rgba(255, 166, 42, 0.5)';
export const bgWarnDefault = 'rgba(255, 166, 42, 1)';
export const bgWarnActive = 'rgba(255, 199, 120, 1)';
export const bgSuccessLightHover = 'rgba(60, 214, 163, 0.24)';
export const bgSuccessLightDisabled = 'rgba(60, 214, 163, 0.08)';
export const bgSuccessLightDefault = 'rgba(60, 214, 163, 0.16)';
export const bgSuccessLightActive = 'rgba(60, 214, 163, 0.32)';
export const bgSuccessHover = 'rgba(99, 224, 183, 1)';
export const bgSuccessDisabled = 'rgba(60, 214, 163, 0.5)';
export const bgSuccessDefault = 'rgba(60, 214, 163, 1)';
export const bgSuccessActive = 'rgba(141, 235, 203, 1)';
export const bgStaticLight = 'rgba(255, 255, 255, 1)';
export const bgStaticDarkMedium = 'rgba(59, 63, 71, 1)';
export const bgStaticDarkLow = 'rgba(40, 44, 51, 1)';
export const bgDangerLightHover = 'rgba(238, 83, 71, 0.24)';
export const bgDangerLightDisabled = 'rgba(238, 83, 71, 0.08)';
export const bgDangerLightDefault = 'rgba(238, 83, 71, 0.16)';
export const bgDangerLightActive = 'rgba(238, 83, 71, 0.32)';
export const bgDangerHover = 'rgba(245, 144, 137, 1)';
export const bgDangerDisabled = 'rgba(240, 115, 105, 0.5)';
export const bgDangerDefault = 'rgba(240, 115, 105, 1)';
export const bgDangerActive = 'rgba(250, 175, 170, 1)';
export const bgBrandLightHover = 'rgba(144, 127, 240, 0.24)';
export const bgBrandLightDisabled = 'rgba(144, 127, 240, 0.08)';
export const bgBrandLightActive = 'rgba(144, 127, 240, 0.32)';
export const bgBrandLightDefault = 'rgba(144, 127, 240, 0.16)';
export const bgTagHover = 'rgba(255, 255, 255, 0.24)';
export const bgTagDisabled = 'rgba(255, 255, 255, 0.08)';
export const bgTagDefault = 'rgba(255, 255, 255, 0.16)';
export const bgTagActive = 'rgba(255, 255, 255, 0.32)';
export const bgScrollbarHover = 'rgba(255, 255, 255, 0.24)';
export const bgScrollbarDefault = 'rgba(255, 255, 255, 0.16)';
export const bgScrollbarActive = 'rgba(255, 255, 255, 0.32)';
export const bgMaskDefault = 'rgba(0, 0, 0, 0.72)';
export const bgControlsHover = 'rgba(255, 255, 255, 0.16)';
export const bgControlsElevateHigh = 'rgba(255, 255, 255, 0.24)';
export const bgControlsElevateDefault = 'rgba(255, 255, 255, 0.12)';
export const bgControlsDisabled = 'rgba(255, 255, 255, 0.08)';
export const bgControlsDefault = 'rgba(255, 255, 255, 0.08)';
export const bgControlsActive = 'rgba(255, 255, 255, 0.24)';
export const bgCommonHighest = 'rgba(51, 51, 51, 1)';
export const bgCommonHigh = 'rgba(38, 38, 38, 1)';
export const bgCommonDefault = 'rgba(26, 26, 26, 1)';
export const bgBrandHover = 'rgba(168, 154, 245, 1)';
export const bgBrandDisabled = 'rgba(144, 127, 240, 0.5)';
export const bgBrandDefault = 'rgba(144, 127, 240, 1)';
export const bgBrandActive = 'rgba(192, 182, 250, 1)';
export const bgBglessHover = 'rgba(255, 255, 255, 0.08)';
export const bgBglessActive = 'rgba(255, 255, 255, 0.16)';
export const bgCommonLower = 'rgba(13, 13, 13, 1)';
export const rainbowTeal5 = ' rgba(62, 222, 169, 1)';
export const rainbowTeal4 = ' rgba(62, 222, 169, 0.8)';
export const rainbowTeal3 = ' rgba(62, 222, 169, 0.6)';
export const rainbowTeal2 = ' rgba(25, 215, 151, 0.4)';
export const rainbowTeal1 = ' rgba(62, 222, 169, 0.2)';
export const rainbowTangerine5 = 'rgba(255, 147, 46, 1)';
export const rainbowTangerine4 = ' rgba(255, 147, 46, 0.8)';
export const rainbowTangerine3 = ' rgba(255, 147, 46, 0.6)';
export const rainbowTangerine2 = ' rgba(255, 147, 46, 0.4)';
export const rainbowTangerine1 = ' rgba(255, 147, 46, 0.2)';
export const rainbowRed5 = ' rgba(240, 115, 105, 1)';
export const rainbowRed4 = ' rgba(240, 115, 105, 0.8)';
export const rainbowRed3 = ' rgba(240, 115, 105, 0.6)';
export const rainbowRed2 = ' rgba(240, 115, 105, 0.4)';
export const rainbowRed1 = ' rgba(213, 84, 75, 0.2)';
export const rainbowPurple5 = ' rgba(144, 127, 240, 1)';
export const rainbowPurple4 = ' rgba(144, 127, 240, 0.8)';
export const rainbowPurple3 = ' rgba(144, 127, 240, 0.6)';
export const rainbowPurple2 = ' rgba(144, 127, 240, 0.4)';
export const rainbowPurple1 = ' rgba(144, 127, 240, 0.2)';
export const rainbowPink5 = ' rgba(255, 122, 147, 1)';
export const rainbowPink4 = ' rgba(255, 122, 147, 0.8)';
export const rainbowPink3 = ' rgba(255, 122, 147, 0.6)';
export const rainbowPink2 = ' rgba(255, 122, 147, 0.4)';
export const rainbowPink1 = ' rgba(255, 112, 139, 0.2)';
export const rainbowOrange5 = ' rgba(255, 166, 42, 1)';
export const rainbowOrange4 = ' rgba(255, 166, 42, 0.8)';
export const rainbowOrange3 = ' rgba(255, 166, 42, 0.6)';
export const rainbowOrange2 = ' rgba(255, 166, 42, 0.4)';
export const rainbowOrange1 = ' rgba(255, 170, 0, 0.2)';
export const rainbowIndigo5 = ' rgba(114, 152, 247, 1)';
export const rainbowIndigo4 = ' rgba(114, 152, 247, 0.8)';
export const rainbowIndigo3 = ' rgba(114, 152, 247, 0.6)';
export const rainbowIndigo2 = ' rgba(114, 152, 247, 0.4)';
export const rainbowIndigo1 = ' rgba(85, 134, 255, 0.2)';
export const rainbowGreen5 = ' rgba(109, 204, 61, 1)';
export const rainbowGreen4 = ' rgba(109, 204, 61, 0.8)';
export const rainbowGreen3 = ' rgba(109, 204, 61, 0.6)';
export const rainbowGreen2 = ' rgba(109, 204, 61, 0.4)';
export const rainbowGreen1 = ' rgba(82, 196, 27, 0.2)';
export const rainbowBrown5 = ' rgba(204, 147, 106, 1)';
export const rainbowBrown4 = ' rgba(204, 147, 106, 0.8)';
export const rainbowBrown3 = ' rgba(191, 124, 76, 0.6)';
export const rainbowBrown2 = ' rgba(204, 147, 106, 0.4)';
export const rainbowBrown1 = ' rgba(204, 147, 106, 0.2)';
export const rainbowBlue5 = ' rgba(92, 207, 255, 1)';
export const rainbowBlue4 = ' rgba(92, 207, 255, 0.8)';
export const rainbowBlue3 = ' rgba(92, 207, 255, 0.6)';
export const rainbowBlue2 = ' rgba(92, 207, 255, 0.4)';
export const rainbowBlue1 = ' rgba(92, 207, 255, 0.2)';
export const shadowSideRightHigh = '6px 0px 12px rgba(0, 0, 0, 0.16), 3px 0px 6px rgba(0, 0, 0, 0.12)';
export const shadowSideRightDefault = '4px 0px 8px rgba(0, 0, 0, 0.16), 2px 0px 4px rgba(0, 0, 0, 0.16)';
export const shadowSideLeftHigh = '-6px 0px 12px rgba(0, 0, 0, 0.16), -3px 0px 6px rgba(0, 0, 0, 0.12)';
export const shadowSideLeftDefault = '-4px 0px 8px rgba(0, 0, 0, 0.16), -2px 0px 4px rgba(0, 0, 0, 0.16)';
export const shadowCommonHighest = '0px 3px 6px rgba(0, 0, 0, 0.12), 0px 12px 24px rgba(0, 0, 0, 0.16)';
export const shadowCommonHigh = '0px 2px 4px rgba(0, 0, 0, 0.12), 0px 6px 12px rgba(0, 0, 0, 0.16)';
export const shadowCommonDefault = '0px 3px 6px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.16)';
export const cellSelectedColorSolid = '#2C293B';
export const rowSelectedBgSolid = '#2B2B2B';
export const primaryLightSolid = '#2C293B';
export const gradientBgMask = 'linear-gradient(270deg, #1A1A1A 0%, rgba(26, 26, 26, 0) 100%)';
export const warnLightHover = 'rgba(255, 166, 42, 0.24)';
export const warnLightActive = 'rgba(255, 166, 42, 0.32)';
export const warnLight = 'rgba(255, 166, 42, 0.16)';
export const warnHover = 'rgba(255, 183, 82, 1)';
export const warnActive = 'rgba(255, 199, 120, 1)';
export const warn = 'rgba(255, 166, 42, 1)';
export const successLightHover = 'rgba(60, 214, 163, 0.24)';
export const successLight = 'rgba(60, 214, 163, 0.16)';
export const successHover = 'rgba(99, 224, 183, 1)';
export const successActive = 'rgba(141, 235, 203, 1)';
export const success = 'rgba(60, 214, 163, 1)';
export const scrollBar = 'rgba(255, 255, 255, 0.16)';
export const reverse1 = '#E0E0E0';
export const reverse0 = '#333333';
export const extraLightTeal = 'rgba(60, 214, 163, 0.16)';
export const extraLightRed = 'rgba(238, 83, 71, 0.16)';
export const extraLightPrimary = 'rgba(144, 127, 240, 0.16)';
export const extraLightOrange = 'rgba(255, 166, 42, 0.16)';
export const extraLightIndigo = 'rgba(114, 152, 247, 0.16)';
export const successLightActive = 'rgba(60, 214, 163, 0.32)';
export const linkVisted = 'rgba(123, 103, 238, 1)';
export const linkHover = 'rgba(168, 154, 245, 1)';
export const linkActive = 'rgba(192, 182, 250, 1)';
export const link = 'rgba(144, 127, 240, 1)';
export const staticWhite2 = 'rgba(255, 255, 255, 0.6)';
export const staticWhite1 = 'rgba(255, 255, 255, 0.8)';
export const staticDark2 = '#171822';
export const staticDark1 = '#262838';
export const staticDark0 = '#5E607E';
export const fill2 = 'rgba(255, 255, 255, 0.24)';
export const fill1 = 'rgba(255, 255, 255, 0.16)';
export const fill0 = 'rgba(255, 255, 255, 0.08)';
export const defaultTag = 'rgba(255, 255, 255, 0.16)';
export const staticWhite0 = '#FFFFFF';
export const highestBg = 'rgba(51, 51, 51, 1)';
export const highBg = 'rgba(38, 38, 38, 1)';
export const errorLightHover = 'rgba(238, 83, 71, 0.24)';
export const errorLightActive = 'rgba(238, 83, 71, 0.32)';
export const errorLight = 'rgba(238, 83, 71, 0.16)';
export const errorHover = 'rgba(245, 144, 137, 1)';
export const errorActive = 'rgba(250, 175, 170, 1)';
export const primaryLight = 'rgba(144, 127, 240, 0.16)';
export const primaryLightHover = 'rgba(139, 122, 240, 0.24)';
export const primaryLightActive = 'rgba(144, 127, 240, 0.16)';
export const primaryActive = 'rgba(192, 182, 250, 1)';
export const primaryHover = 'rgba(168, 154, 245, 1)';
export const fc19 = 'rgba(144, 127, 240, 0.16)';
export const foundMark = 'rgba(144, 127, 240, 0.16)';
export const fc18 = 'rgba(255, 166, 42, 0.16)';
export const currentSearch = 'rgba(255, 166, 42, 0.16)';
export const fc17 = 'rgba(0, 0, 0, 0.12)';
export const calendarWeekend = 'rgba(0, 0, 0, 0.12)';
export const fc9 = 'rgba(144, 127, 240, 0.16)';
export const cellSelectedColor = 'rgba(144, 127, 240, 0.16)';
export const fc8 = 'rgba(26, 26, 26, 1)';
export const defaultBg = 'rgba(26, 26, 26, 1)';
export const white = 'rgba(26, 26, 26, 1)';
export const fc7 = 'rgba(255, 255, 255, 0.08)';
export const rowSelectedBg = 'rgba(255, 255, 255, 0.08)';
export const fc6 = 'rgba(13, 13, 13, 1)';
export const lowestBg = 'rgba(13, 13, 13, 1)';
export const fc5 = 'rgba(255, 255, 255, 0.12)';
export const lineColor = 'rgba(255, 255, 255, 0.12)';
export const fc4 = 'rgba(255, 255, 255, 0.4)';
export const fourthLevelText = 'rgba(255, 255, 255, 0.4)';
export const fc3 = 'rgba(255, 255, 255, 0.55)';
export const thirdLevelText = 'rgba(255, 255, 255, 0.55)';
export const fc2 = 'rgba(255, 255, 255, 0.7)';
export const secondLevelText = 'rgba(255, 255, 255, 0.7)';
export const fc16 = 'rgba(144, 127, 240, 0.16)';
export const treeSelectedBg = 'rgba(144, 127, 240, 0.16)';
export const fc15 = 'rgba(60, 214, 163, 1)';
export const successColor = 'rgba(60, 214, 163, 1)';
export const fc14 = 'rgba(255, 183, 82, 1)';
export const warningColor = 'rgba(255, 183, 82, 1)';
export const fc13 = 'rgba(224, 224, 224, 1)';
export const tooltipBg = 'rgba(224, 224, 224, 1)';
export const fc12 = 'rgba(0, 0, 0, 0.6)';
export const deepMaskColor = 'rgba(0, 0, 0, 0.6)';
export const fc11 = 'rgba(61, 61, 61, 1)';
export const sheetLineColor = 'rgba(61, 61, 61, 1)';
export const shadowColor = 'rgba(61, 61, 61, 1)';
export const fc10 = 'rgba(240, 115, 105, 1)';
export const errorColor = 'rgba(240, 115, 105, 1)';
export const fc1 = 'rgba(255, 255, 255, 0.85)';
export const firstLevelText = 'rgba(255, 255, 255, 0.85)';
export const fc0 = '#907FF0';
export const primaryColor = '#907FF0';
